import { ExtractPropTypes } from 'vue'
import StepItem from './step-item.vue'
import Steps from './steps.vue'

import { buildProps, definePropType } from '@ll-plus/utils'
import { StepsProps as AntStepsProps } from 'ant-design-vue'

export type stepsType = AntStepsProps['type'] | 'tabs' | 'breadcrumb'
export type stepsFooterPositional = 'left' | 'center' | 'right'

// props
export const stepsProps = buildProps({
  width: {
    type: String,
    default: '100%',
  },
  height: {
    type: String,
    default: 'auto',
  },
  // 步骤条内边距
  stepPadding: {
    type: String,
    default: '12px 48px 0 48px',
  },
  items: {
    type: definePropType<AntStepsProps['items']>(Array),
  },
  current: {
    type: Number,
  },
  initial: {
    type: Number,
    default: 0,
  },
  // 方向
  direction: {
    type: definePropType<AntStepsProps['direction']>(String),
  },
  // 类型
  type: {
    type: definePropType<stepsType>(String),
  },
  // 步骤内容
  content: {
    type: Boolean,
    default: true,
  },
  // 页脚
  footer: {
    type: Boolean,
    default: true,
  },
  // 页脚对齐方位
  footerPositional: {
    type: definePropType<stepsFooterPositional>(String),
    default: 'right',
  },
  // 是否可点击
  clicked: {
    type: Boolean,
    default: true,
  },
  // 点状
  progressDot: {
    type: Boolean,
    default: false,
  },
  // 左对齐
  left: {
    type: Boolean,
    default: true,
  },
  // 迷你尺寸
  miniSize: {
    type: Boolean,
    default: true,
  },
} as const)

// props
export type StepsProps = ExtractPropTypes<typeof stepsProps>

// 导出steps实列类型
export type StepsInstance = InstanceType<typeof Steps>
export type StepItemInstance = InstanceType<typeof StepItem>
